import { render, staticRenderFns } from "./add-product.vue?vue&type=template&id=81f3f0e8&scoped=true&"
import script from "./add-product.vue?vue&type=script&lang=js&"
export * from "./add-product.vue?vue&type=script&lang=js&"
import style0 from "./add-product.vue?vue&type=style&index=0&id=81f3f0e8&scoped=true&lang=css&"
import style1 from "./add-product.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f3f0e8",
  null
  
)

export default component.exports